/**
 * Spec 034 (2/2) — a lógica pura da coluna "Cliente" e das mensagens dos
 * vínculos, sem React nem cliente HTTP, para o teste da API importar
 * (apps/api/src/shared/user-clients-column.test.ts).
 */
import type { UserClientLink } from '@erp/shared';

/** userId → nomes dos clientes, na ordem da API (por nome). */
export function clientNamesByUser(rows: UserClientLink[] | undefined): Map<number, string[]> {
  const out = new Map<number, string[]>();
  for (const r of rows ?? []) {
    const names = out.get(r.userId) ?? [];
    names.push(r.clientName);
    out.set(r.userId, names);
  }
  return out;
}

/** O texto da célula: o primeiro cliente e "+N" quando há mais (spec 034). */
export function clientCellText(
  names: readonly string[] | undefined
): { first: string; more: number } | null {
  if (!names || names.length === 0) return null;
  return { first: names[0] as string, more: names.length - 1 };
}

/** Códigos da API de vínculos → mensagem para o admin (sem o termo do tenant: sem concordância a errar). */
export function userClientsErrorMessage(code: string): string {
  switch (code) {
    case 'last_client_link':
      return 'É o único vínculo deste login: sem ele, o portal fica vazio. Para trocar, vincule o novo antes de tirar este.';
    case 'client_not_found':
      return 'Cadastro não encontrado — a lista pode estar desatualizada.';
    case 'client_user_not_found':
      return 'Este vínculo já não existe — a lista pode estar desatualizada.';
    case 'user_not_found':
      return 'Usuário não encontrado — a lista pode estar desatualizada.';
    case 'not_a_portal_login':
      return 'Só logins do portal têm vínculos.';
    case 'forbidden':
      return 'Só administradores alteram vínculos.';
    case 'impersonation_read_only':
      return 'Sessão "ver como" é só leitura.';
    default:
      return 'Não foi possível salvar. Tente de novo.';
  }
}
